var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"badge-wrapper",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),(_vm.amount > 0)?_c('div',{staticClass:"badge",class:_vm.position},[_vm._v(_vm._s(_vm.amount))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }